import React, { useMemo, useState } from 'react';
import ESpinner from '../components/ESpinner';
import { useCustomAxios } from '../Hooks/useAxios';
// import { placeholderData } from './dummy-data';
import { useNavigate, useParams } from 'react-router';
import { BsArrowLeft } from 'react-icons/bs';
import FButton from '../components/FButton';
import { axiosInstance } from '../api/requister';

const headers = [
    { id: 1, title: "Document Name" },
    { id: 2, title: "GDrive or TF" },
    { id: 3, title: "Send/Sent to GVision" },
    { id: 4, title: "ID" },
    { id: 5, title: "Type" },
    { id: 6, title: "Category" },
    { id: 7, title: "Date Modified" },
    { id: 8, title: "Archived" },
    { id: 9, title: "NPI" },
    { id: 10, title: "Important" },
    { id: 11, title: "Notes" },
    { id: 12, title: "URL" },
    { id: 13, title: "Corrupt" }
];


const DocumentTable = () => {
    const fileId = useParams().id;
    const navigate = useNavigate();
    const { response: data, error, loading, Refetch } = useCustomAxios({
        method: 'GET',
        url: `util/fileDetailsWithinRange/?id=${fileId}`
    });
    
    // Local state to manage document updates
    const [localData, setLocalData] = useState([]);
    
    // Update local state when data changes
    React.useEffect(() => {
        if (data) {
            setLocalData(data);
        }
    }, [data]);

    // Handle GVision checkbox change
    const handleGVisionChange = async (documentId, currentValue) => {
        const isChecked = currentValue === "x";
        const newValue = isChecked ? "" : "x";
        
        // Update local state immediately for better UX
        setLocalData(prevData => 
            prevData.map(doc => 
                doc.id === documentId 
                    ? { ...doc, sentToGVision: newValue }
                    : doc
            )
        );

        try {
            // Make API call to update the server with the new payload format
            await axiosInstance.post(`util/fileDetailsWithinRange/`, {
                workbench_id: fileId, // Using the fileId from useParams as the sheet_id
                row_id: documentId, // Col AD - unique identifier for row
                is_checked: !isChecked // Toggle the current state
            });
        } catch (error) {
            console.error('Error updating GVision status:', error);
            // Revert local state on error
            setLocalData(prevData => 
                prevData.map(doc => 
                    doc.id === documentId 
                        ? { ...doc, sentToGVision: currentValue }
                        : doc
                )
            );
            alert('Failed to update GVision status. Please try again.');
        }
    };

    // const headers = useMemo(() => [...Object.keys(data?.at(0) || {}), 'actions'], [data]);
    // const headers = useMemo(() => [...Object.keys(data?.at(0) || {})], [data]);


    // Use actual data if available, otherwise use placeholder  
    // const data = :?.data?.length > 0 ? response.data : [];
    // console.log({ data })

    const handleScript = () => {
        const tableData = data || [];
        console.log({ tableData });
    };

    const content = loading ? (
        <div className="h-full flex flex-col items-center justify-center bg-white bg-opacity-80 z-10">
            <ESpinner size={25} isVisible />
            <p>Loading...</p>
        </div>
    ) : error ? (
        <div className="h-full flex flex-col items-center justify-center p-8 text-center">
            <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-red-100">
                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
            </div>
            <h2 className="mb-2 text-xl font-medium text-gray-900">Unable to load documents</h2>
            <p className="mb-6 text-gray-600">
                {"We couldn't retrieve the document list. Please try again."}
            </p>
            <button
                onClick={Refetch}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                Try Again
            </button>
        </div>
    ) : !loading && !error && localData.length === 0 ? (
        <div className="p-8 text-center italic text-gray-500">No documents found.</div>
    ) : (
        <table className="w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10">
                <tr>
                    {headers.map(header => (
                        <th
                            key={header.id}
                            className="px-6 py-3 text-left text-xs font-medium 
                            text-gray-500 uppercase tracking-wider w-[10%]">
                            {header.title}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
                {localData.map((document) => (
                    <tr
                        key={document.id}
                        className="hover:bg-gray-50"
                    >
                        <td className="px-6 py-4 whitespace-nowrap w-[10%]">{document.docList}</td>
                        <td className="px-6 py-4 whitespace-nowrap w-[7%]">{document.gdriveOrTf}</td>
                        <td className="px-6 py-4 whitespace-nowrap w-[12%]">
                            <input 
                                type="checkbox" 
                                checked={document.sentToGVision === "x"} 
                                onChange={() => handleGVisionChange(document.id, document.sentToGVision)}
                                className="cursor-pointer"
                            />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap w-[7%]">{document.id}</td>
                        <td className="px-6 py-4 whitespace-nowrap w-[7%]">{document.type}</td>
                        <td className="px-6 py-4 whitespace-nowrap w-[7%]">{document.category || '-'}</td>
                        <td className="px-6 py-4 whitespace-nowrap w-[13%]">
                            {Date.parse(document.dateModified) ? new Date(document.dateModified).toLocaleString() : '-'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap w-[7%]">
                            {document.archived ? 'Yes' : 'No'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap w-[10%]">
                            {document.npi ? 'Yes' : 'No'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap w-[7%]">
                            {document.important ? 'Yes' : 'No'}
                        </td>
                        <td className="px-6 py-4 w-[14%]">
                            <div className="max-w-full overflow-hidden text-ellipsis whitespace-nowrap">
                                {document.notes || '-'}
                            </div>
                        </td>
                        <td className="px-6 py-4 w-[14%]">
                            <div className="max-w-full overflow-hidden text-ellipsis whitespace-nowrap">
                                <a
                                    href={document.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 hover:text-blue-800 hover:underline"
                                    onClick={(e) => e.stopPropagation()} // Prevent row click event
                                >
                                    {document.url}
                                </a>
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap w-[6%]">
                            {document.corrupt ? 'Yes' : 'No'}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )

    return (
        <div className="h-screen p-8 bg-gray-50">
            {/* Header */}
            <div className="flex items-center gap-4 mb-8">
                <button className='bg-slate-50 rounded-full p-2 hover:bg-slate-100' onClick={() => navigate(`/file/${fileId}`)}>
                    <BsArrowLeft />
                </button>
                <h1 className="text-2xl font-semibold text-gray-800">Document Table</h1>
                <FButton onClick={handleScript} className="ml-auto text-xl px-6">Update Document List</FButton>
            </div>

            {/* Table Container */}
            <div className="h-[95%] relative overflow-auto bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5"
                style={{ boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)' }}>
                {content}
            </div>
        </div>
    );
};

export default DocumentTable;